import axios from 'axios';
import config from '../../config';
import { client } from '@/services';
import { getSelectedVenue } from '@/services/helpers';

const assetsService = client.service('assets');
const uploadsService = client.service('uploads');
const playlistService = client.service('playlists');
const scheduleService = client.service('schedules');

const assets = {
  namespaced: true,
  state: {
    assets: [],
    assetsUnassigned: [],
    loaded: false,
    settings: {}
  },
  getters: {
    GET_ASSETS: state => state.assets,
    GET_ASSETS_UNASSIGNED: state => state.assetsUnassigned,
    GET_LOADED_STATUS: state => state.loaded,
    GET_ASSETS_SETTINGS: state => state.settings
  },
  mutations: {
    SET_ASSETS(state, assets) {
      state.assets = assets;
      state.loaded = true;
    },
    SET_ASSETS_UNASSIGNED(state, assets) {
      state.assetsUnassigned = assets;
      state.loaded = true;
    },
    REMOVE_ASSET(state, _id) {
      const stateAssetIndex = state.assets.findIndex(asset => asset._id === _id);
      const stateUnassingedAssetIndex = state.assetsUnassigned.findIndex(
        asset => asset._id === _id
      );

      if (stateAssetIndex >= 0) {
        state.assets.splice(stateAssetIndex, 1);
      }
      if (stateUnassingedAssetIndex >= 0) {
        state.assetsUnassigned.splice(stateUnassingedAssetIndex, 1);
      }
    },
    SET_SETTINGS_ASSETS(state, assetsConfig) {
      state.settings = assetsConfig;
    }
  },
  actions: {
    async GET_ASSETS({ commit }) {
      const assets = await assetsService.find({
        query: {
          venueId: getSelectedVenue()._id,
          $paginate: {
            value: false
          }
        }
      });

      assets.forEach(asset => {
        if (asset.thumbnail) {
          asset.serverPath = `${config.server_url}/uploads/thumbs/${asset.thumbnail}`;
        }
      });

      commit('SET_ASSETS', assets);
      return assets;
    },
    async GET_ASSET_BY_ASSETSFOLDERID(_, assetsFolderId) {
      return (
        await assetsService.find({
          query: {
            assetsFolderId: assetsFolderId
          }
        })
      ).data;
    },
    async GET_ASSET_UNASSIGNED({ commit }) {
      try {
        const playlists = await playlistService.find({
          query: {
            venueId: getSelectedVenue()._id,
            $paginate: {
              value: false
            }
          }
        });
        const schedules = await scheduleService.find({
          query: {
            venueId: getSelectedVenue()._id,
            sourceType: 'App',
            $or: [{ appId: { $ne: null } }, { appId: { $ne: '' } }, { appId: { $exists: false } }],
            $paginate: {
              value: false
            }
          }
        });
        const assetIdsAssigned = playlists
          .map(playlist => playlist.items.map(item => item.assetId))
          .flat();

        for (let schedule of schedules) {
          if (schedule.appId) {
            assetIdsAssigned.push(schedule.appId);
          }
        }

        const assets_unassigned = await assetsService.find({
          query: {
            _id: {
              $nin: assetIdsAssigned
            },
            venueId: getSelectedVenue()._id,
            $paginate: {
              value: false
            }
          }
        });

        commit('SET_ASSETS_UNASSIGNED', assets_unassigned);
        return assets_unassigned;
      } catch (error) {
        throw error;
      }
    },
    async GET_ASSET(_, _id) {
      var asset = await assetsService.get(_id);

      if (asset.thumbnail) {
        asset.serverPath = `${config.server_url}/uploads/thumbs/${asset.thumbnail}`;
      }

      return asset;
    },
    async DOWNLOAD_ASSET(_, id) {
      const response = await uploadsService.get(id);
      return response;
    },
    async GET_APPS({}) {
      const apps = await assetsService.find({
        query: {
          venueId: getSelectedVenue()._id,
          $paginate: {
            value: false
          },
          $search: '.zip'
        }
      });

      return apps;
    },
    async GET_DEVICE(_, _id) {
      const response = await devicesService.get(_id);
      return response;
    },
    async ADD_ASSET({ rootState }, asset) {
      const clone = JSON.parse(JSON.stringify(asset));
      clone.created_at = Date.now();
      clone.userId = rootState.users.user._id;
      clone.venueId = getSelectedVenue()._id;
      const response = await assetsService.create(clone);
      /* commit('ADD_DEVICE', response) */
      return response;
    },
    async UPDATE_ASSET(_, payload) {
      try {
        if (payload.currentUploadId) {
          await uploadsService.remove(payload.currentUploadId);
        }

        return await assetsService.update(payload._id, payload.asset);
      } catch (error) {
        throw error;
      }
    },
    async PATCH_ASSET(_, payload) {
      await assetsService.patch(payload._id, payload);
    },
    async DELETE_ASSETS({ commit, dispatch }, assets) {
      try {
        const statuses = [];

        for (let x of assets) {
          const playlists = await dispatch('playlists/SEARCH_ASSET', x._id, { root: true });
          const schedules = await dispatch('schedules/SEARCH_APP_ASSET', x._id, { root: true });

          if (playlists.length > 0 || schedules.length > 0) {
            playlists.length > 0 &&
              statuses.push({ status: 'error', type: 'playlist', asset: x, response: playlists });
            schedules.length > 0 &&
              statuses.push({ status: 'error', type: 'schedule', asset: x, response: schedules });
          } else {
            try {
              statuses.push({ status: 'success', asset: x });
              await assetsService.remove(x._id);
              await uploadsService.remove(x.uploadId);
            } catch (e) {}

            commit('REMOVE_ASSET', x._id);
          }
        }

        return statuses;
      } catch (e) {
        throw e;
      }
    },
    async UPDATE_DEVICE({ rootState, commit }, payload) {
      payload.device.created_at = Date.now();
      delete payload.device._id;
      const response = await devicesService.patch(payload._id, payload.device);
      const groups = rootState.groups.groups;
      const i = groups.findIndex(g => g._id === response.groupId);
      response.groupName = i >= 0 ? groups[i].name : 'No group yet.';
      commit('UPDATE_DEVICE', response);
      return response;
    },
    async DELETE_DEVICE({ commit }, _id) {
      await devicesService.remove(_id);
      commit('REMOVE_DEVICE', _id);
    },
    async GET_FORMATTING_CONFIG({}) {
      const defaults = await axios.get(config.server_url + '/api/settings/cms-client-config');

      return JSON.parse(defaults.data.config);
    },
    async GET_ASSETS_SETTINGS({ commit }) {
      try {
        const response = await axios.get(`${config.server_url}/settings?_=${Date.now()}`);
        const assetsConfig = response.data.assets;

        commit('SET_SETTINGS_ASSETS', assetsConfig);
        return assetsConfig;
      } catch (error) {
        console.error('Error fetching assets settings:', error);
        throw error;
      }
    }
  }
};

export default assets;



// WEBPACK FOOTER //
// ./src/store/modules/assets.js